import Api from "lib/api/httpRequestHelper";

export const getUserNotifications = async () => {
  return await Api.get(
    "list-notifications-user",
    "notification",
    "?quantidadeNotificacoes=20",
    true
  );
};

export const getUserAllNotifications = async () => {
  return await Api.get(
    "list-notifications-user",
    "notification",
    "?quantidadeNotificacoes=60",
    true
  );
};

export const updateUserFirebaseId = async (idFirebase) => {
  return await Api.post(
    "create-user-relationship-firebase",
    "notification",
    { idFirebase },
    true
  );
};

export const removeUserFirebaseId = async (idFirebase) => {
  return await Api.post(
    "remove-user-relationship-firebase",
    "notification",
    { idFirebase },
    true
  );
};
